import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState }    from 'react';
import api                        from '../api';
import LegalUpdateDetail          from '../pages/LegalUpdateDetail.js';

export default function LegalUpdateModal () {
  const { id }    = useParams();
  const navigate  = useNavigate();
  const [update, setUpdate] = useState(null);


  useEffect(() => {
    api.get(`/legal-update/legal-updates/${id}`)
       .then(r => setUpdate(r.data))
       .catch(() => navigate('/legal-update', { replace: true }));
  }, [id, navigate]);

  return (
    <LegalUpdateDetail
    open={Boolean(update)}
    update={update}
    onClose={() => navigate(-1)}
    onRefresh={async () => {
      const { data } = await api.get(`/legal-update/legal-updates/${id}`);
      setUpdate(data);
    }}
    onEdit={u => {
      navigate(`/legal-update?edit=${u._id}`, { replace: true });
    }}
  />
  
  );
}
